var map = {
	"./alarm_value_management.svg": "c4ty",
	"./function.svg": "wB4m",
	"./home.svg": "U9Ws",
	"./language.svg": "+Dip",
	"./orangnization.svg": "S5kW",
	"./quota_management.svg": "wAns",
	"./role.svg": "cqqK",
	"./user.svg": "VdD3",
	"./user_permissions.svg": "Wyab"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 11